import React, { useState } from 'react'
import Wrapper from '../helpers/Wrapper'
import AnimatePage from '../components/AnimatePage'
import { ChangePageTitle } from '../helpers/ChangeTitle'
import LinkButton from '../ui/LinkButton'
import Input from '../components/Form Elements/Input'
import TextArea from '../components/Form Elements/TextArea'
import Button from '../ui/Button'
import { useMutation } from '@tanstack/react-query'
import { apiClient } from '../helpers/Axios'
import toast from 'react-hot-toast'

function Contact() {
    ChangePageTitle("Contact")

    const [formData, setFormData] = useState({ name: "", email: "", message: "" })

    const handleOnchange = (e) => {
        const { value, id } = e.target
        setFormData({ ...formData, [id]: value })
    }

    // Send email

    const { mutate, isPending } = useMutation({
        mutationFn: (payload) => {
            return apiClient.post('/contact', payload)
        },
        onError: (error) => {
            toast.dismiss()
            toast.error(error?.response?.data || error?.message)
        },
        onSuccess: (data) => {
            toast.dismiss()
            toast.success(data.data || "Message sent successfully")
            setFormData({ name: "", email: "", message: "" })
        }
    })

    const sendMessage = () => {
        mutate(formData)
    }

    return (
        <div className="w-full relative">
            <AnimatePage>

                {/* Address Location */}
                <div className="w-full">
                    <iframe
                        title='Map1'
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3970.7013746787134!2d-0.2080526!3d5.6110467!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xfdf9bcabef09fe3%3A0xc772a0273c654fc0!2sEco%20Shoppe%20Ghana%20%7C%20Gift%20Shop%20%7C%20Souvenirs%20%7C%20Shopping%20Mall%20%7C%20Gift%20Wrapping%20Store!5e0!3m2!1sen!2sgh!4v1730589106466!5m2!1sen!2sgh"
                        width="100%" height="450" style={{ border: '0' }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
                    />
                </div>

                {/* Content  */}
                <Wrapper>
                    <div className="w-full mt-20">
                        {/* Need Help */}
                        <div className="w-full">
                            <div className="space-y-4">
                                <h2 className='text-[clamp(1rem,2vw+1rem,2rem)] font-medium'>Here to Help</h2>
                                <p className="text-gray-500 text-[clamp(0.9rem,2vw+1rem,1rem)]">
                                    Have a question? You may find an answer in our FAQs. But you can also contact us:
                                </p>
                                <LinkButton to='/pages/faq' black>Go to faq's</LinkButton>
                            </div>
                        </div>

                        {/* Get In touch */}
                        <div className="mt-24">
                            <div className="space-y-4">
                                <h2 className='text-[clamp(1rem,2vw+1rem,2rem)] font-medium'>Get in Touch</h2>
                                <p className="text-gray-500 text-[clamp(0.9rem,2vw+1rem,1rem)]">
                                    We'd love to hear from you about our entire service. Your comments and suggestions will be highly appreciated.
                                    Please complete the form below.
                                </p>
                            </div>

                            {/* Contact  Form  */}
                            <div className="w-full space-y-1.5 mt-10">
                                <div className="flex flex-col md:flex-row md:items-center gap-4">
                                    <Input placeholder="Name" id="name" value={formData.name} onChange={handleOnchange} />
                                    <Input placeholder="Email" id="email" value={formData.email} onChange={handleOnchange} />
                                </div>
                                <div className="w-full">
                                    <TextArea placeholder="Message" id="message" value={formData.message} onChange={handleOnchange} />
                                </div>
                                <div>
                                    <Button onClick={sendMessage} loading={isPending}>send message</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Wrapper>
            </AnimatePage>
        </div>
    )
}

export default Contact